/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Import STL reference model</h4>

<p>Import an STL model, to use as reference. The model will be displayed in green and will not be editable.</p>`;

export default function ImportSTLTooltip() {
    return h('div', { innerHTML: body });
}
